<nav class="site-header navbar navbar-expand-lg navbar-light fixed-top">
  <div class="container">
    <!-- Brand -->
    <a class="navbar-brand fw-bold" routerLink="/" aria-label="Alphatec Scientific">
      <img src="assets/logo/logo-alp-dark.png" alt="Alphatec Scientific" class="brand-img">
    </a>

    <!-- Toggler -->
    <button class="navbar-toggler shadow-none" type="button" data-bs-toggle="collapse" data-bs-target="#mainNav"
      aria-controls="mainNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- Nav + CTA -->
    <div id="mainNav" class="collapse navbar-collapse flex-lg-grow-1">
      <!-- MENÚ CENTRADO -->
      <ul class="navbar-nav nav-center mb-2 mb-lg-0 align-items-lg-center">
        <li class="nav-item">
          <a class="nav-link" routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">
            {{ t('nav.home') }}
          </a>
        </li>

        <!-- Mega menú Productos -->
        <li class="nav-item dropdown position-static">
          <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown">
            {{ t('nav.products') }}
          </a>

          <!-- CENTRADO -->
          <div class="dropdown-menu mega mega--center p-0">
            <div class="mega__inner container py-3">
              <div class="row g-2">
                <div class="col-6 col-md-3" *ngFor="let c of cats">
                  <a class="mega-item" [routerLink]="['/categoria', c.slug]">
                    <img *ngIf="c.iconUrl" [src]="c.iconUrl" class="icon me-2" alt="">
                    <span>{{ c.name }}</span>
                  </a>
                </div>
              </div>
              <div class="text-center mt-3">
                <a class="btn btn-sm btn-orange-outline" routerLink="/tienda">{{ t('nav.allCats') }}</a>
              </div>
            </div>
          </div>
        </li>

        <!-- Software -->
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown">
            {{ t('nav.software') }}
          </a>
          <ul class="dropdown-menu shadow-lg text-center">
            <li><a class="dropdown-item" routerLink="/software/lis">{{ t('software.lis') }}</a></li>
            <li><a class="dropdown-item" routerLink="/software/bloodBank">{{ t('software.bb') }}</a></li>
            <li><a class="dropdown-item" routerLink="/software/vet-lis">{{ t('software.vet') }}</a></li>
          </ul>
        </li>

        <li class="nav-item"><a class="nav-link" routerLink="/nosotros" routerLinkActive="active">{{ t('nav.about') }}</a></li>
        <li class="nav-item"><a class="nav-link" routerLink="/contacto" routerLinkActive="active">{{ t('nav.contact') }}</a></li>
      </ul>

      <!-- CTA / Derecha -->
      <div class="header-cta d-flex align-items-center gap-2 ms-lg-3">
        <!-- Selector de idioma -->
        <div class="dropdown lang-switch">
          <button
            class="btn btn-lang dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            [attr.aria-label]="t('aria.changeLang')">
            <img [src]="currentFlag" alt="" class="flag">
          </button>
          <ul class="dropdown-menu dropdown-menu-end shadow-lg">
            <li *ngFor="let l of langs">
              <button class="dropdown-item d-flex align-items-center gap-2" type="button" (click)="setLang(l.code)">
                <img [src]="l.flag" alt="" class="flag">
                <span class="lang-label">{{ l.label }}</span>
              </button>
            </li>
          </ul>
        </div>

        <!-- Carrito -->
        <a class="btn btn-cart position-relative" routerLink="/cart" [attr.aria-label]="t('aria.cart')">
          <i class="bi bi-cart"></i>
          <span *ngIf="cart.count() > 0"
                class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger cart-badge">
            {{ cart.count() }}
          </span>
        </a>
      </div>
    </div>
  </div>
</nav>
